const snack             = require ('../../../../../../components/snack/snack')
const dialog            = require ('../../purchase/purchase-dialog')
const textfieldHandler  = require ('../../../../../../components/textfield/textfield-handler')
const dtpurchasechanges = require('../../purchase/purchase-dt-handler')
const autocomplete      = require ('../../../../../../components/textfield/autocomplete')
const calculateHandler  = require('./purchase-fullcont-calculate-handler')
const handler           = require('./purchase-fullcont-handler')
const snackP            = require ('../../purchase/purchase-snack')
const inf               = require ('../../../../../../js-network/inf')


export function cogsPercent(detail, htmlFc) {}

export function disableopcion(detail){

  //disable-mode-edit
  const input_check = document.querySelector("#purchase_check_opcion_" + detail.line + " input" );
  let input_cant    = document.querySelector("#purchase_cant_opcion_" + detail.line);

  if (input_check.checked) {
    input_cant.classList.remove("textfield-disabled");
  }else{
    input_cant.classList.add("textfield-disabled");

  }
}

export function changeBilleOn(){

  let input_delivered_date = document.querySelector("#purchase_form_delivered_date3 input");
  let bill_date            = document.querySelector("#purchase_form_bill_date3");
  let input_bill_date      = document.querySelector("#purchase_form_bill_date3 input");

  if (!bill_date.classList.contains('textfield-restriction')) {

    input_bill_date.value = input_delivered_date.value;
  }
}

export function dtgenerator(result, htmlFc) {
  let dtBody       = htmlFc.fullcontHTML.querySelector('#purchase-changes3');
  dtBody.innerHTML = '';

  if (result.entitychanges.length > 0 && (result.entitychanges[0].data[0].user_name != null || result.entitychanges[0].data[0].user_name != undefined)) {

      let data            = result.entitychanges[0].data;
      let dataorganizeRow = [];
      dataorganizeRow     = dtpurchasechanges.organizeRowEntityChange(data);
      let saleChanges     = htmlFc.fullcontHTML.querySelector('#purchase-changes3')
      saleChanges.insertAdjacentHTML("beforeend", dataorganizeRow)  
    
  } 
}

export function cleandtfullcont(htmlFc) {
   
  let dtBody       = htmlFc.fullcontHTML.querySelector('#purchase-changes3');
  dtBody.innerHTML = '';
}

export function goToQtyField(detail, htmlFc) {
  let ac_line = htmlFc.fullcontHTML.querySelector("#purchase_form_item_qty_" + detail.id_ac + " input");
  ac_line.focus();
}

export async function verifyPayment(htmlFc, dbid) {

  let data       = { id: dbid };
  const formData = new FormData();
  formData.append('purchase_id', data.id);

  const controller = new AbortController();
  const timeout    = setTimeout(() => { controller.abort() }, 30000);

  let options = {
    method: 'POST',
    body: formData,
    signal: controller.signal,
    credentials: 'same-origin'
  };

  try {
    const result = await fetch(`./server/php/sql/purchasepayment.php`, options);
    const paymentData = await result.json();

    if (paymentData.restriction.val == "PurchaseHasPayment") {
      snack.start({ act: 'show', id: 'purchaseHasPayment', });
      return true;
    } else {
      return false;
    }

    // Aquí puedes continuar con el código que depende de los datos de la petición fetch
  } catch (error) {
    //console.log('Error:', error);
    
    return false;
  } finally {
    clearTimeout(timeout);
  }
}

//Para poner que no se pueda cambiar el item o eliminar si este tiene sale, solo permitir  cambiar sus propiedades 
//como la cantidad o la unidad etc.
export function itemWithSale(result) {

  result.multiTables.forEach(element => {
      if(element.tableName=="purchase_vs_item"){

        element.data.forEach(item_data => {

          let lines = document.querySelectorAll("#purchase_form_purchase_vs_item3  .line");
          lines.forEach(line => {
            let item       = line.querySelector('.item_id');
            let otherfield = item.querySelector(".otherField").getAttribute('otherField');

            if ( JSON.parse(otherfield).id == parseInt(item_data.id) && JSON.parse(otherfield).sold_qty > 0   ) {
              item.classList.add('textfield-autocomplete-disabled');
              item.closest('.line').classList.add('mt-purchase-restriction');
              let removeElement = item.closest('.line').querySelector('.removeLine');;
              // Nuevo valor para el atributo data-detail
              let newDataDetail = '{"click": [{"dest":"ripple"}, {"dest":"purchase", "elem":"fullcont", "act":"removeItem"}]}';

              // Reemplazar el valor del atributo data-detail
              removeElement.setAttribute('data-detail', newDataDetail);
            }
          });
        });
      }
  });
}

//para verificar que las cantidades de los articulos no sean menor a la cantidad vendida mas la cantidad perdida y mas la cantidad retornada
export async function verifyItemQtyUsed(htmlFc) {
  let dbid = htmlFc.fullcontHTML.getAttribute("data-dbid");
  let data = { id: dbid };
  const formData = new FormData();
  formData.append('purchase_id', data.id);

  const controller = new AbortController();
  const timeout    = setTimeout(() => { controller.abort() }, 30000);

  let options = {
    method: 'POST',
    body: formData,
    signal: controller.signal,
    credentials: 'same-origin'
  };

  try {
    const result    = await fetch(`./server/php/sql/purchaseitemsold.php`, options);
    let result_data = await result.json();
    result_data     = result_data.data;

    for (let index = 0; index < result_data.length; index++) {
      let lines = htmlFc.fullcontHTML.querySelectorAll("#purchase_form_purchase_vs_item23 .line");

      for (let i = 0; i < lines.length; i++) {
        let item       = lines[i].querySelector('.item_id');
        let item_selected = item.getAttribute("selected");
        item_selected     = JSON.parse(item_selected);
        if (item_selected.length > 0) {
          let input      = lines[i].querySelector('.qty input');
          let otherfield = item.querySelector(".otherField").getAttribute('otherField');
          let qty_used   = parseFloat(result_data[index].sold_qty) + parseFloat(result_data[index].lost_qty) + parseFloat(result_data[index].returned_qty);
  
          if ( JSON.parse(otherfield).id == parseInt(result_data[index].id) && parseFloat(input.value) < qty_used ) {
            textfieldHandler.error(lines[i].querySelector('.qty'));
  
            let info = `The ${JSON.parse(otherfield).name} product has been used ${qty_used} units and fewer units
            are being placed than those sold: ${parseFloat(input.value)} units`;
  
            dialog.start({ act: "show", dest: 'purchase', id: "purchaseItemQtySold", entity: 'purchase', info: info });
            return false;
          }
        }

      }
      
    }
  

    // Aquí puedes continuar con el código que depende de los datos de la petición fetch
  } catch (error) {
    
    return false;
  } finally {
    clearTimeout(timeout);
  }
  return true;
}

export function beforeAutocomplete(detail,htmlFc){ 
  let dbid          = htmlFc.fullcontHTML.getAttribute("data-dbid");
  detail.act        = "click"
  detail.acMoreData = { fields:['purchase.id'], values: [dbid] }
  autocomplete.start(detail)
}

//esta funcion es para verificar su hubo un error luego del update
export function processAfterUpdate(data,result){
  handler.itemWithSale(result);
  //actualizar el array con el inventario
  calculateHandler.fill_InventoryStock_spentCredit(data);

  if (result.restriction.val == "insufficientQuantity" || result.restriction.message == "insufficientQuantity" ) {
    snackP.start({ act: 'show', id: 'insufficientQuantity', });
  }

  if (result.restriction.val == "insufficientPrice" || result.restriction.message == "insufficientPrice" ) {
    snackP.start({ act: 'show', id: 'insufficientPrice', });
  }

  calculateHandler.calculate_total_lost_returned();

}

//mostrar el mt de lost
export function showMtlost(htmlFc) {

  let showMtlost = htmlFc.fullcontHTML.querySelector("#showMtlost3").checked;

  if (showMtlost) {
    let mt_lost = htmlFc.fullcontHTML.querySelector("#mt_lost3");
    mt_lost.classList.remove('dn');
  
  }else{
    let mt_lost = htmlFc.fullcontHTML.querySelector("#mt_lost3");
    mt_lost.classList.add('dn');
    
  }

  calculateHandler.calculate_total_lost_returned();
  
}

//mostrar la seccion de lost
export function showLost() {
  let lost  =  document.querySelector('#lost3');
  lost.classList.remove('dn');

  EventClickShowHideMt(false)
}

//ocultar la seccion de lost
export function hideLost() {
  let lost  =  document.querySelector('#lost3');
  lost.classList.add('dn');
}

export function EventClickShowHideMt(action) {
    let event             = new Event('change');
    let showLostInput     =  document.querySelector('#showMtlost3');
    showLostInput.checked = action;
  
    event = new Event('change');
    showLostInput.dispatchEvent(event);
}


// funcion para validar que el monto total del purchase no supere el monto pagado en sentpayment
// tambien con los cogs que no superen los pagos que tienen asi como si eliminan un cogs que tiene pago debe recargar el fullcont
export async function validatedPuchasePayment(htmlFc) {
  let dbid       = htmlFc.fullcontHTML.getAttribute("data-dbid");
  let data       = { id: dbid };
  const formData = new FormData();
  formData.append('purchase_id', data.id);
  formData.append('before_update', '1');

  const controller = new AbortController();
  const timeout    = setTimeout(() => { controller.abort() }, 30000);

  let options = {
    method: 'POST',
    body: formData,
    signal: controller.signal,
    credentials: 'same-origin'
  };

  try {
    const result = await fetch(`./server/php/queries/entityFunction/purchase-paymentValidate.php`, options);
    const paymentData = await result.json();

    if (paymentData.data.length > 0) {
      return processPuchasePayment(paymentData.data,htmlFc);
    }
    return true;


    // Aquí puedes continuar con el código que depende de los datos de la petición fetch
  } catch (error) {
    
    return false;
  } finally {
    clearTimeout(timeout);
  }
}


function processPuchasePayment(data,htmlFc) {

  //recorrer el resultado del query con los datos de los sentpayment
  for (let index = 0; index < data.length; index++) {
    let expense_type = data[index].expense_type;
    let expense_id = data[index].expense_id;
    let sent_amount = parseFloat(data[index].sent_amount);

    if (expense_type == "Purchase") {
      let total_PVI = 0;
      let allLinePVI   = htmlFc.fullcontHTML.querySelectorAll("#purchase_form_purchase_vs_item3  .line");
      // recorrer el MT de purchase vs item
      for (let index2 = 0; index2 < allLinePVI.length; index2++) {
        const line = allLinePVI[index2];
        let ac_item       = line.querySelector(".item_id")
        let item_selected = ac_item.getAttribute("selected");
        item_selected     = JSON.parse(item_selected);
        //sumar el total de los item del mt
        if (item_selected.length > 0) {
          let input_totalPrice = line.querySelector(".total_price input");
          let totalPrice_value      = (input_totalPrice.value == "" || parseFloat(input_totalPrice.value) == NaN || parseFloat(input_totalPrice.value) == 0) ? 0 :
          parseFloat(input_totalPrice.value);
          total_PVI = total_PVI + totalPrice_value;
        }
      }
      //si el total del los item es menor que el valor pagado no permitir guardar y mostrar notificacion
      if (total_PVI < sent_amount) {
        allLinePVI.forEach(line => {
          let textfieldTotalPrice = line.querySelector(".total_price")
          textfieldHandler.error(textfieldTotalPrice);
        });
        
        snackP.start({ act: 'show', id: 'purchaseTotalLessThanPayment', sent_amount: sent_amount});
        return false;
      }

    }else{
      let allLinePVE   = htmlFc.fullcontHTML.querySelectorAll("#purchase_form_purchase_vs_expenses3  .line");
      let existCOGSPayment = false;
      let amountCOGSIsLowerPayment = false;
      let textfieldAmount = undefined;
      // recorrer el mt de purchase vs expenses
      for (let index = 0; index < allLinePVE.length; index++) {
        let line = allLinePVE[index];
        let cogs_id = line.getAttribute('lineid'); 

        // validar que el cogs pagado exista en el mt y si existe validar que la cantidad no sea menor a la pagada
        if (expense_id == cogs_id) {
          existCOGSPayment = true;
          let inputAmount  = line.querySelector(".amount input")
          let Amount_value = (inputAmount.value == "" || parseFloat(inputAmount.value) == NaN || parseFloat(inputAmount.value) == 0) ? 0 :
          parseFloat(inputAmount.value);
          if (Amount_value < sent_amount) {
            amountCOGSIsLowerPayment = true;
            textfieldAmount = inputAmount;
          }
          break;
        }
      }

      // si el cogs no existe pues se debera recargar la pagina para que el cogs salga ya que fue eliminado
      if (!existCOGSPayment) {
        snackP.start({ act: 'show', id: 'NotExistCOGS'});
        return false;
      }

      // si el valor del cogs es menor al pagado se mostrara notificacion y no se permitira guardar
      if (amountCOGSIsLowerPayment) {
        textfieldHandler.error(textfieldAmount.closest(".textfield"));
        snackP.start({ act: 'show', id: 'cogsAmountLessThanPayment',sent_amount: sent_amount });
        return false;
      }

  
    }
    
  }

  return true;

}